/**
 * @generated SignedSource<<b531a02c23e389fbc2f35479ec0771e3>>
 * @relayHash 429f9d5d3eb7b6be0e8841c3fb9e4370
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 1ae9801936ae195530c93b0c6660f4bf179d4b5ca51367da5ef475a1e8eea200

import type { ConcreteRequest, Query } from 'relay-runtime';
export type LivePageContentQuery$variables = {
  contentId?: string | null | undefined;
};
export type LivePageContentQuery$data = {
  readonly singleContent: {
    readonly history: {
      readonly createdDate: string | null | undefined;
    } | null | undefined;
    readonly id: string | null | undefined;
    readonly space: {
      readonly id: string | null | undefined;
    } | null | undefined;
  } | null | undefined;
};
export type LivePageContentQuery = {
  response: LivePageContentQuery$data;
  variables: LivePageContentQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "contentId"
  }
],
v1 = {
  "kind": "ScalarField",
  "name": "id"
},
v2 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "contentId"
      }
    ],
    "concreteType": "Content",
    "kind": "LinkedField",
    "name": "singleContent",
    "plural": false,
    "selections": [
      (v1/*: any*/),
      {
        "concreteType": "Space",
        "kind": "LinkedField",
        "name": "space",
        "plural": false,
        "selections": [
          (v1/*: any*/)
        ]
      },
      {
        "concreteType": "History",
        "kind": "LinkedField",
        "name": "history",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "createdDate"
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "LivePageContentQuery",
    "selections": (v2/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "LivePageContentQuery",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "429f9d5d3eb7b6be0e8841c3fb9e4370",
    "id": "1ae9801936ae195530c93b0c6660f4bf179d4b5ca51367da5ef475a1e8eea200",
    "metadata": {},
    "name": "LivePageContentQuery",
    "operationKind": "query",
    "text": "query LivePageContentQuery($contentId:ID){singleContent(id:$contentId){id,space{id},history{createdDate}}}"
  }
};
})();

(node as any).hash = "c8206062f6c8abf19211cd9ce5a75343";

export default node;
